<!--
  This icon is designed especially for Concertgebouw and not from an icon set,
  so be careful reusing it in other projects.
  -->

<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" role="graphics-symbol">
    <g fill="currentColor">
      <path
        class="st0"
        d="M19.5 10c-.3-.3-.8-.5-1.3-.5h-.7v-4c0-1.5-.6-2.9-1.6-3.9S13.4 0 12 0c-1.6 0-3 .6-4 1.6-1.1 1-1.6 2.4-1.6 3.9v3.9h-.6c-.5 0-.9.2-1.3.5-.3.4-.5.9-.5 1.4v10.9c0 .5.2.9.5 1.3.4.3.8.5 1.3.5h12.4c.5 0 .9-.2 1.3-.5.3-.3.5-.8.5-1.3V11.3c0-.5-.2-1-.5-1.3zM8 5.5c0-1 .4-2 1.2-2.8.7-.7 1.7-1.1 2.8-1.1 1.1 0 2 .4 2.8 1.1.7.7 1.2 1.7 1.2 2.8v3.9H8V5.5zm10.4 16.7s0 .1-.1.1l-.1.1H5.8c-.1 0-.1 0-.1-.1l-.1-.1V11.3s0-.1.1-.1l.1-.1h12.4s.1 0 .1.1l.1.1v10.9z"
      />
      <path
        class="st0"
        d="M12.5 15.7c-.2-.1-.5-.1-.8-.1-.3.1-.5.2-.7.4-.2.2-.3.4-.4.7-.1.3 0 .5.1.8.1.2.2.4.4.5v.3c0 .2.1.4.2.6.2.2.4.2.6.2.2 0 .4-.1.6-.2.2-.2.2-.4.2-.6v-.4s.1 0 .1-.1c.2-.2.4-.6.4-.9 0-.3-.1-.5-.2-.7 0-.3-.3-.4-.5-.5z"
      />
    </g>
  </svg>
</template>
